import { marked, Renderer } from 'marked';

const renderer = new Renderer();
renderer.html = () => '';
renderer.link = (href, title, text) => {
  const safeHref = href ?? '';
  const titleAttr = title ? ` title="${title}"` : '';
  return `<a href="${safeHref}"${titleAttr} target="_blank" rel="noopener noreferrer">${text}</a>`;
};

marked.setOptions({
  gfm: true,
  breaks: true,
  renderer,
});

export const renderArielAiMarkdown = (markdown: string): string => {
  if (!markdown.trim()) {
    return '';
  }
  return marked.parse(markdown) as string;
};
